/**
 * Shared date/time formatting using the user's locale and timezone.
 */
export function formatDateTime(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  const parsed = value instanceof Date
    ? value
    : parseUtcDate(String(value));
  if (Number.isNaN(parsed.getTime())) {
    return typeof value === 'string' ? value : '';
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(parsed);
}

export function formatDate(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  const parsed = value instanceof Date
    ? value
    : parseUtcDate(String(value));
  if (Number.isNaN(parsed.getTime())) {
    return typeof value === 'string' ? value : '';
  }

  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(parsed);
}

export function parseUtcDate(value: string): Date {
  if (!value) {
    return new Date(NaN);
  }
  const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value);
  return new Date(hasTimezone ? value : `${value}Z`);
}

export function formatRelativeTime(value?: string | Date | null): string {
  if (!value) {
    return '';
  }
  const date = value instanceof Date ? value : parseUtcDate(String(value));
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const diffMs = Date.now() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  if (diffMinutes < 1) return 'Just now';
  if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
  return formatDateTime(date);
}
